// Query for general form data

export const USER_DETAILS = `
  query {
    properties {
      user {
        userId
        instId
        accountId
        email
        firstname
        lastname
        role
        groupId
        accountType
        apitoken(service: "aap") {
          success
          access_token
          scope
          expires_in
          token_type
          message        
        }
        uiid:analytics_user_id
      }
    }
  }
`;

export const USER_LOGOUT = `
    query($userID: Int!) {
        user(id: $userID) {
            logout {
                status
            }
        }
    }
`;

export const AUDIENCE_QUERY = `
  query {
    audience {
      audienceList{
        averageBrowsingSessionTimeSecondsNonSearchSiteAllTime,
        averageBrowsingSessionTimeSecondsOtherInstitutionNonSearchSiteAllTime,
        averageExperienceSessionTimeSecondsAllTime,
        averageExperienceSessionTimeSecondsOtherInstitutionAllTime,
        birthDate,
        citizenship,
        city,
        country,
        currentSchool,
        email,
        enrollTerm,
        enrollYear,
        firstName,
        gender,
        graduationYear,
        hasAppliedAllTime,
        hasAppliedOtherInstitutionAllTime,
        hasBrowsedNonSearchSiteAllTime,
        hasBrowsedOtherInstitutionNonSearchSiteAllTime,
        hasInquiredInfoAllTime,
        hasInquiredInfoOtherInstitutionAllTime,
        hasRegisteredAllTime,
        hasRegisteredOtherInstitutionAllTime,
        hasRegisteredWithYouvisit,
        hasScheduledVisitAllTime,
        hasScheduledVisitOtherInstitutionAllTime,
        hasViewedExperienceAllTime,
        hasViewedExperienceOtherInstitutionAllTime,
        hasVisitedSearchSite,
        institutionId,
        lastDateActiveWithInstitution,
        lastDateActiveWithYouvisit,
        lastDateBrowsingOtherInstitutionNonSearchSite,
        lastDateViewingInstitutionExperience,        
        lastName,
        lastDateActiveWithYouvisit,
        major,
        needsVisa,
        phone,
        postal,
        referrer,
        state,
        street,
        totalTimeSpentWithInstitutionSecondsAllTime,
        userKeyConsolidated,
        visitorType,
        relativeInterestLevel
      }
    }
  }
`;

export const userMetricsQuery = `
query ($inst_id: String!, $accountId:String!) {
  institution: institutions(instID: $inst_id) {
    name
  }
  audience {
    listMetrics(instId: $inst_id, accountId:  $accountId){
      listTotalCount
      listSharedCountInclusive
      listSharedCountExclusive
    }
  }
}
`;
